import { useState, useEffect, useCallback, useContext } from 'react'

import ContactPersonsTable from './ContactPersonsTable'
import { OrderBy } from '../../../utils/constants'
import { TableParameters } from '../../../utils/entities/tableParameters'
import DefaultContainer from '../../../HOC/DefaultContainer'
import { Metadata, retrieveMetadata } from '../../../utils/http'
import { getMaccsContactPersons } from '../../../utils/api/institution'
import { isSchoolMaccsUser } from '../../../utils/roles'
import { getSchoolSpecialitiesContactPersons } from '../../../utils/api/contactPerson'
import ContactPersonDrawer from '../../../Providers/Drawer/ContactPerson/ContactPersonDrawer'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import VisibilityValues from '../../shared/ContactPersons/VisibilityValues'

const DEFAULT_TABLE_PARAMS = {
  order: { by: OrderBy.EMAIL },
  pageSize: 50
}

const ExternalContactPersonsView = () => {
  const { user } = useContext(GlobalContext)

  const [tableParameters, setTableParameters] = useState(new TableParameters({ ...DEFAULT_TABLE_PARAMS }))
  const [contactPersons, setContactPersons] = useState({ loading: false, data: [], metadata: new Metadata() })

  const fetchContactPersons = useCallback((parameters = {}) => {
    setContactPersons(prevState => ({ ...prevState, loading: true }))

    if (isSchoolMaccsUser(user)) {
      getSchoolSpecialitiesContactPersons(user, user.school, { ...parameters, contexts: ['institutions'] }).then(({ data, meta }) => {
        setContactPersons(prev => ({ ...prev, data, loading: false, metadata: retrieveMetadata(meta) }))
      })
    } else {
      getMaccsContactPersons(user, user.institutions[0], { ...parameters, contexts: ['school'] }).then(({ data, meta }) => {
        setContactPersons(prev => ({ ...prev, data, loading: false, metadata: retrieveMetadata(meta) }))
      })
    }
  }, [user.id])

  useEffect(() => {
    fetchContactPersons({ ...tableParameters, visibility: VisibilityValues.EXTERNAL })
  }, [fetchContactPersons, tableParameters])

  return (
    <DefaultContainer useTabs offset={40}>
      <ContactPersonDrawer>
        <ContactPersonsTable
          visibility={VisibilityValues.EXTERNAL}
          data={contactPersons.data}
          filters={tableParameters.filters}
          metadata={contactPersons.metadata}
          loading={contactPersons.loading}
          tableParameters={tableParameters}
          onFiltersChange={(value, key) => setTableParameters(prev => ({ ...prev, filters: { ...prev.filters, [key]: value } }))}
          onTableParametersChange={setTableParameters}
        />
      </ContactPersonDrawer>
    </DefaultContainer>
  )
}

export default ExternalContactPersonsView
